import { types } from 'mobx-state-tree';

import MobileNavigationTab, {
  MobileNavigationTabType,
} from '../../types/MobileNavigationTab';
import { blockScroll, unblockScroll } from '../../util/dom';
import Modal from './Modal';

const MobileNavigation = Modal.named('MobileNavigation')
  .props({
    mobileMenuHeight: types.maybeNull(types.number),
    activeTab: types.optional(
      MobileNavigationTabType,
      MobileNavigationTab.PRODUCTS
    ),
  })
  .actions((self) => {
    return {
      updateMenuHeight(height) {
        self.mobileMenuHeight = height;
      },
      selectTab(tab) {
        self.activeTab = tab;
      },
      close() {
        self.isOpen = false;
        unblockScroll();
      },
      open() {
        self.isOpen = true;
        blockScroll();
      },
    };
  });

export default MobileNavigation;
